import React, { useEffect, useState } from "react";
import ShoppingCartProgressBar
    from "../../../components/ecommerce/shopping-cart-progress/shopping-cart-progress.component";
import Col from "react-bootstrap/Col";
import NewShoppingCartItems from "../../../components/ecommerce/new-shopping-cart-items/shopping-cart-items.component";
import ShoppingCartSidebar from "../../../components/ecommerce/shopping-cart-sidebar/shopping-cart-sidebar.component";
import EmptyShoppingCart
    from "../../../components/ecommerce/new-shopping-cart-items/empty-shopping-cart/empty-shopping-cart";
import AssignAttendeeFormListing from "../../../components/ecommerce/forms/assign-attendee-form-listing/assign-attendee-form-listing.component";
import { ENDPOINTS } from "../../../js/api/_config";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getPageDataByApiUrl } from "../../../js/api/get-pages.data";
import { addCartAttendeesAction } from "../../../redux/shopping-cart/shopping-cart.action";
import { getAttendees } from "../../../js/api/shopping-cart/_attendees-cart";
import { useHistory } from "react-router";

function ShoppingCartWrapperComponent({ cartItems, MainContent }) {

    {/* RP - Webinar Attendee Changes - Start */}
    // const [contentData, setContentData] = React.useState(null);
    // const history = useHistory();
    // const dispatch = useDispatch();
    // const cartitems = useSelector(({ cart }) => cart.cart, shallowEqual);
    // const [trainingProduct, settrainingProduct] = useState(null);
    // const [totalattendeesrequired, setTotalattendeesrequired] = useState(0);
    // const attendeescountupdate = useSelector(
    //     ({ cart }) => cart.attendeescount_update,
    //     shallowEqual
    // );
    // const user = useSelector(({ user }) => user.tokens.access_token);
    // const [attendeesSessionTypeName, setAttendeesSessionTypeName] = useState(cartitems.AttendeesSessionTypeName);
    // const cartitemimpersonate = useSelector(
    //     ({ cart }) => cart.impersonateMember
    // );

    // const getCartAttendees = async () => {
    //     let memberId;
    //     if (cartitemimpersonate) {
    //         memberId = cartitemimpersonate.memberId;
    //     }
    //     const getResponse = await getAttendees(memberId);
    //     return getResponse;
    // };

    // useEffect(() => {
    //     if (cartItems !== undefined && cartItems.ItemsCount > 0 && cartItems.OrderLines && cartItems.OrderLines.length == 1 &&
    //         cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0) != null &&
    //         Object.keys(cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0)).length > 0) {
    //         async function getDataFromURL() {
    //             let response = await getPageDataByApiUrl(ENDPOINTS.USER_CART_ACCOUNT.ATTENDEES_CART_URL);
    //             return response;
    //         }
    //         getDataFromURL().then(response => {
    //             setContentData(response)
    //         });
    //     }
    // }, [cartItems]);

    // useEffect(() => {
    //     if (cartItems !== undefined && cartItems.ItemsCount > 0 && cartItems.OrderLines && cartItems.OrderLines.length == 1 &&
    //         cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0) != null &&
    //         Object.keys(cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0)).length > 0) {

    //         const hasTraining = cartitems.OrderLines.filter(orderline => orderline.Category === 'Training').length;

    //         if (hasTraining === 0) {
    //             history.push('shopping-cart');
    //         }
    //         if (hasTraining > 0) {
    //             const trainings = cartitems.OrderLines.filter(orderline => orderline.Category === 'Training');

    //             let prod = [];
    //             let totalattendeesrequired = [];
    //             trainings.forEach(element => {
    //                 if (attendeesSessionTypeName.includes(element.SessionTypeName.toLowerCase())) {
    //                     prod.push({
    //                         productTitle: element.ProductName,
    //                         quantity: element.Quantity,
    //                         sku: element.Sku,
    //                         variantsku: element.VariantSku,
    //                         sessionTypeName: element.SessionTypeName,
    //                         relatedattendees: []
    //                     });
    //                     totalattendeesrequired = totalattendeesrequired.concat([{
    //                         variantsku: element.VariantSku,
    //                         quantity: element.Quantity,
    //                     }]);
    //                 }
    //             });

    //             setTotalattendeesrequired(totalattendeesrequired);

    //             async function checkUserLoggedIn(items) {

    //                 if (user) {
    //                     let cartcount = 0;
    //                     const getcartitemResponse = await getCartAttendees();

    //                     if (getcartitemResponse) {
    //                         const attendees = getcartitemResponse.Attendees;
    //                         dispatch(addCartAttendeesAction(attendees));

    //                         if (attendees && attendees.length > 0) {
    //                             cartcount = attendees.length;
    //                             //ordercart.OrderLines.forEach((a) => (cartcount += a.Quantity));
    //                             if (items) {
    //                                 items.forEach(element => {
    //                                     if (element.variantsku) {
    //                                         const hasItem = attendees.filter(m => m.VariantSku === element.variantsku && m.Sku === element.sku);
    //                                         if (hasItem.length > 0) {
    //                                             element.relatedattendees = hasItem;
    //                                         }
    //                                     } else {
    //                                         const hasItem = attendees.filter(m => m.Sku === element.sku);
    //                                         if (hasItem.length > 0) {
    //                                             element.relatedattendees = hasItem;
    //                                         }
    //                                     }
    //                                 });
    //                             }
    //                         }
    //                     }
    //                     settrainingProduct(items);
    //                 }
    //             }

    //             checkUserLoggedIn(prod);
    //         }
    //     }
    // }, [attendeescountupdate, cartItems]);
    {/* RP - Webinar Attendee Changes - End */}

    return (
        <>
            {
                (cartItems !== undefined && cartItems.ItemsCount > 0) ?
                    <>
                        <ShoppingCartProgressBar />
                        <Col xs={12} md={8} lg={8} style={{ marginTop: -20 }}>
                            <NewShoppingCartItems mainContent={MainContent} />
                            {/* RP - Webinar Attendee Changes - Start */}
                            {/* {cartItems !== undefined && cartItems.ItemsCount > 0 && cartItems.OrderLines && cartItems.OrderLines.length == 1 &&
                                cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0) != null &&
                                Object.keys(cartItems.OrderLines.find(x => x.SessionTypeName == "Webinar" && x.Price == 0)).length > 0 &&
                                <div>
                                    <AssignAttendeeFormListing dropdowndata={contentData?.CustomDropDownContent} products={trainingProduct} />
                                    <br />
                                    <br />
                                </div>} */}
                            {/* RP - Webinar Attendee Changes - End */}
                        </Col>
                        <Col xs={12} md={4} lg={4} className="sidebar xs-only-trinity-container">
                            <ShoppingCartSidebar buttonText="Continue" mainContent={MainContent} />
                            {/* <ShoppingCartSidebar buttonText="Continue" mainContent={MainContent} products={trainingProduct} /> */}
                        </Col>
                    </>
                    :
                    <Col xs={12} md={12} lg={12}>
                        <EmptyShoppingCart />
                    </Col>
            }
        </>
    )
}

export default ShoppingCartWrapperComponent;
